import { dataLoading } from "@/shared/decorators/LoadingAction.decorator";
import apiClient from "./ApiClientService";
import { FaultCode } from "@/shared/models/FaultCode";

export class FaultCodeApi {
  @dataLoading([])
  static async getAllFaultCodes(): Promise<FaultCode[]> {
    const result = await apiClient.get("faultcode");
    if (result.status === 200 && result.data) {
      return (result.data as FaultCode[]).sort((a, b) => a.id! - b.id!);
    }
    return [];
  }

  @dataLoading([])
  static async getActiveFaultCodes(): Promise<FaultCode[]> {
    const result = await apiClient.get("faultcode/active");
    if (result.status === 200 && result.data) {
      return result.data as FaultCode[];
    }
    return [];
  }

  static async getFaultCodeById(id: number): Promise<FaultCode | null> {
    const result = await apiClient.get(`faultcode/${id}`);
    if (result.status === 200 && result.data) {
      return result.data as FaultCode;
    }
    return null;
  }

  static async createFaultCode(request: FaultCode): Promise<boolean> {
    const result = await apiClient.post("faultcode", request);
    return result.status === 200;
  }

  static async updateFaultCode(request: FaultCode): Promise<boolean> {
    const result = await apiClient.put("faultcode", request);
    return result.status === 200;
  }

  static async deleteFaultCode(id: number): Promise<boolean> {
    const result = await apiClient.delete(`faultcode/${id}`);
    return result.status === 204 || result.status === 200;
  }
}
